export default function Config($stateProvider) {
  'ngInject';
  $stateProvider.state('app.account.moves', {
    url: '/moves',
    views: {
      'accountContent@app.account': {
        template: '<upd-account-moves></upd-account-moves>',
      },
    },
    params: {
      // Pass in `verified` in the $stateParams to show success message
      verified: undefined,
    },
    title: 'My Moves',
    analytics: {
      page: 'Account Moves',
    },
  });
}
